<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-create"
      centered
      modal-class="modal-primary"
      ok-only
      ok-title="Add"
      @ok="addJobTitle"
    >
      <b-form-group label="Job Title">
        <b-form-input v-model="addForm.name" placeholder="Enter Job Title" />
      </b-form-group>
    </b-modal>
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button variant="primary" @click="showModal">
            Add Job Title
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="m-2">
      <b-row>
        <b-col cols="12" md="12">
          <br />
        </b-col>
        <b-col cols="12" md="2"> </b-col>
        <b-col md="4">
          <b-form-group
            class="mt-25"
            label="Search Job Title"
            label-for="Job Title"
          >
            <b-form-input
              @keyup.enter="index()"
              v-model="filterData.name"
              placeholder="Enter Job Title"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="2"
          md="2"
          class="d-flex align-items-center justify-content-start mt-75 mb-1 mb-md-0"
        >
          <b-button variant="primary" @click="index()"> Search </b-button>
        </b-col>
      </b-row>
    </div>
    <b-table
      :items="all_data.data"
      responsive
      :fields="tableColumns"
      primary-key="id"
      v-if="!loading"
      show-empty
      empty-text="No matching records found"
      class="position-relative"
    >
      <!-- Column: Id -->
      <template #cell(Id)="data">
        <b-link class="font-weight-bold">
          {{ data.item.id }}
        </b-link>
      </template>

      <!-- Column: Name -->
      <template #cell(Name)="data">
        <b-media vertical-align="center">
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.item.name }}
          </span>
        </b-media>
      </template>

      <!-- Column: created_at -->
      <template #cell(Created_at)="data">
        <span class="text-nowrap">
          {{ data.item.created_at }}
        </span>
      </template>

      <!-- Column: updated_at -->
      <template #cell(Updated_at)="data">
        <span class="text-nowrap">
          {{ data.item.updated_at }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item>
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner label="Loading..." />
        </div>
      </div>
    </template>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing 1 to 10</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
          @click="index()"
        >
          <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="take"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BSpinner,
  VBModal,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { onUnmounted } from '@vue/composition-api';
import Ripple from 'vue-ripple-directive';
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BSpinner,
  },
  data() {
    return {
      tableColumns: [
        { key: 'Id', label: '#', sortable: true },
        { key: 'Name', sortable: true },
        { key: 'Created_at', sortable: true },
        { key: 'Updated_at', sortable: true },
        { key: 'Actions' },
      ],
      loading: true,
      page: 1,
      take: 10,
      totalInvoices: 0,
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalRows: '',
      sortBy: 'id',
      isSortDirDesc: true,
      statusFilter: null,
      addForm: {
        name: '',
      },
      params: {
        form: {},
        path: '',
      },
      filterData: {
        name: '',
        order_status: '',
        order_by: '',
        order_type: '',
      },
    };
  },
  mounted() {
    this.checkAuth().then(() => {
      this.index();
    });
  },
  methods: {
    async index() {
      await this.getList(
        `/title/job?take=${this.take}&page=${this.page}&filter[name]=${this.filterData.name}`
      );
      this.loading = false;
      this.totalRows = this.all_data.total;
    },
    showModal() {
      this.$bvModal.show('modal-create');
    },
    addJobTitle() {
      (this.params.form = this.addForm),
        (this.params.path = '/title/job'),
        this.$store
          .dispatch('create', this.params)
          .then(() => {
            this.loading = true;
            this.index();
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Job Title Created',
                icon: 'success',
                variant: 'info',
                text: 'Job Title ' + this.addForm.name + ' Added Successfully',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
